import {
  GeckoKestrelModel,
  InspectionTypeOverrides,
  KestrelGatekeeper,
  KestrelInspectionType,
} from 'types'

import { GATEKEEPER_DEFAULTS } from './defaults'
import aerospaceOverride from './overrides/aerospace'
import g1n6Override from './overrides/g1n6'
import navyOverride from './overrides/navy'
import rooftopOverride from './overrides/rooftop'
import siteviewOverride from './overrides/siteview'

const OVERRIDES: Partial<
  Record<KestrelInspectionType, InspectionTypeOverrides>
> = {
  [KestrelInspectionType.ROOFTOP]: rooftopOverride,
  [KestrelInspectionType.SITEVIEW]: siteviewOverride,
  [KestrelInspectionType.NAVY]: navyOverride,
  [KestrelInspectionType.G1N6]: g1n6Override,
  [KestrelInspectionType.AEROSPACE]: aerospaceOverride,
}

export function resolveGatekeeper(
  kind: KestrelInspectionType | undefined,
  model: GeckoKestrelModel | undefined
): KestrelGatekeeper {
  const typeKey = kind ?? KestrelInspectionType.DEFAULT
  const overrideEntry = OVERRIDES[typeKey]
  const overrides =
    typeof overrideEntry === 'function'
      ? overrideEntry(model)
      : (overrideEntry ?? {})

  const merged: KestrelGatekeeper = {
    ...GATEKEEPER_DEFAULTS,
    kind: typeKey,
    fallbackUnit: overrides.fallbackUnit ?? GATEKEEPER_DEFAULTS.fallbackUnit,
    feature: { ...GATEKEEPER_DEFAULTS.feature, ...overrides.feature },
    annotationForm: {
      ...GATEKEEPER_DEFAULTS.annotationForm,
      ...overrides.annotationForm,
    },
  }

  return merged
}
